class TeamListingSidebar {
  constructor(component) {
    this.refs = {
      sidebar: '.js-team-listing-sidebar-item',
      link: '.js-team-listing-sidebar-link',
      section: '.js-team-listing-grid',
    };

    this.dom = {
      $component: component,
      $sidebarItems: Array.from(component.querySelectorAll(this.refs.sidebar)),
      $activeSidebarItems: Array.from(component.querySelectorAll(this.refs.sidebar)),
      $links: Array.from(component.querySelectorAll(this.refs.link)),
      $sections: Array.from(document.querySelectorAll(this.refs.section)),
      $activeSections: Array.from(document.querySelectorAll(this.refs.section)),
    };

    this.state = {
      headerOffset: 65,
      currentActiveId: null,
      isScrollingProgrammatically: false,
    }

    if (!this.dom.$sidebarItems.length || !this.dom.$sections.length) return;

    this.onFiltersApplied = this.onFiltersApplied.bind(this);

    this.init();
  }

  init() {
    const { dom } = this;

    // Click links → smooth scroll + immediate active
    dom.$links.forEach(link => {
      link.addEventListener('click', e => this.onLinkClick(e, link));
    });

    // Scroll tracking
    window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    window.addEventListener('resize', () => this.updateActive());

    // Inside TeamListingSidebar constructor/init
    dom.$component.addEventListener('teamlisting:filtersApplied', this.onFiltersApplied);


    this.updateActive(); // initial run
  }

  onLinkClick(e, link) {
    const { state } = this;

    e.preventDefault();

    const targetId = link.getAttribute('href').replace('#', '');
    const targetEl = document.getElementById(targetId);
    if (!targetEl) return;

    const offsetTop = targetEl.getBoundingClientRect().top + window.scrollY - state.headerOffset - 2;

    // Mark as active immediately
    this.setActive(targetId);

    // Flag to suspend normal scroll tracking temporarily
    state.isScrollingProgrammatically = true;

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });

    // Detect scroll completion using a periodic check
    const checkInterval = 10; // ms
    const tolerance = 2; // px tolerance
    const intervalId = setInterval(() => {
      const distance = Math.abs(window.scrollY - offsetTop);
      if (distance <= tolerance) {
        clearInterval(intervalId);
        state.isScrollingProgrammatically = false;
        this.updateActive(); // final update after scroll ends
        if (targetEl) targetEl.focus({ preventScroll: true });
      }
    }, checkInterval);
  }

  onScroll() {
    const { state } = this;
    if (!state.isScrollingProgrammatically) {
      window.requestAnimationFrame(() => this.updateActive());
    }
  }

  onFiltersApplied(e) {
    const { dom } = this;

    const { visibleSectionIds } = e.detail;

    // Hide sidebar items whose sections are hidden
    dom.$sidebarItems.forEach(item => {
      const targetId = item.dataset.target;
      const isVisible = visibleSectionIds.includes(targetId);
      item.classList.toggle('hide', !isVisible);
    });

    // Filter dom.$sidebarItems and dom.$sections to only visible ones
    dom.$activeSidebarItems = dom.$sidebarItems.filter(item => !item.classList.contains('hide'));
    dom.$activeSections = dom.$sections.filter(section => visibleSectionIds.includes(section.id));

    // Update active based on first visible section in viewport
    this.updateActive();
  }

  updateActive() {
    const { dom, state } = this;
    // Trigger line: top of viewport + some fraction
    const triggerLine = state.headerOffset + 50;

    let chosen = null;

    // Find the last section whose top <= triggerLine
    dom.$activeSections.forEach(sec => {
      const rect = sec.getBoundingClientRect();
      if (rect.top <= triggerLine) chosen = sec;
    });

    if (!chosen) chosen = dom.$activeSections[0];

    const id = chosen ? chosen.id : null;

    this.setActive(id);
  }

  setActive(id) {
    const { dom, state } = this;
    if (state.currentActiveId === id) return;

    state.currentActiveId = id;
    dom.$sidebarItems.forEach(item => {
      item.classList.toggle('is-active', item.dataset.target === id);
    });
    dom.$links.forEach(link => {
      link.setAttribute('aria-current', link.closest(this.refs.sidebar)?.dataset.target === id ? 'true' : 'false');
    });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  const $teamListingSidebar = document.querySelector('.js-team-listing-sidebar');
  if (!$teamListingSidebar) return;
  new TeamListingSidebar($teamListingSidebar);
});
